import React from 'react';
import '../styles/NewWindowExample.css';

const NewWindowExample = () => {
  const openNewTab = () => {
    const windowUrl = `${process.env.PUBLIC_URL || ''}/windows/new-tab.html`;
    const newTab = window.open(windowUrl, 'new-tab');

    if (newTab) {
      newTab.name = 'new-tab';
    }
  };

  return (
    <div className="new-window-example" id="content">
      <div className="new-window-card">
        <div className="new-window-icon" aria-hidden="true">
          <i className="fas fa-external-link-alt" />
        </div>
        <h2 className="new-window-heading">Opening a New Window</h2>
        <p className="new-window-description">
          Click the button below to open a new browser window. Practice switching between windows in your automation scripts.
        </p>
        <button
          type="button"
          className="open-window-button"
          onClick={openNewTab}
        >
          <i className="fas fa-window-restore" aria-hidden="true" />
          Click Here
        </button>
      </div>
    </div>
  );
};

export default NewWindowExample;
